import { Dispatch } from 'redux';
import { i18n as i18nType } from 'i18next';
import { STATIC_ACTIONS, SESSION_ACTIONS } from '../../Constants/Actions.constants';
import { INeoAction } from './../Actions.interface';
import { createAction } from '../../Helpers/Action.helpers';

export type ChangeLanguageType = (
  i18n: i18nType,
  language: string,
) => (dispatch: Dispatch<INeoAction>) => void;

export const requestChangeLanguage: ChangeLanguageType = (i18n, language) => (dispatch) => {
  i18n.changeLanguage(language);
  dispatch({ type: STATIC_ACTIONS.CHANGE_LANGUAGE, payload: language });
};

export const requestChangeSearchInput = (text: string) =>
  createAction({ type: STATIC_ACTIONS.SEARCH_INPUT_CHANGED, payload: text });

export const requestSaveSessionData = (key: string, data: any) =>
  createAction({
    type: SESSION_ACTIONS.SESSION_DATA,
    payload: {
      key,
      data,
    },
  });

export const requestClearError = (actionId: string) =>
  createAction({ type: STATIC_ACTIONS.CLEAR_ERROR, payload: actionId });

export const requestMarkDownloadAsDone = (jobId: string) =>
  createAction({
    type: STATIC_ACTIONS.REMOVE_JOB_FROM_REQUEST_LIST,
    name: STATIC_ACTIONS.REMOVE_JOB_FROM_REQUEST_LIST,
    payload: jobId,
  });

export const requestClearImageUpload = () =>
  createAction({
    type: STATIC_ACTIONS.CLEAR_IMAGE_UPLOAD,
    name: STATIC_ACTIONS.CLEAR_IMAGE_UPLOAD,
  });
